// extracted by mini-css-extract-plugin
module.exports = {"packagingMeasuresFormInfo":"packagingMeasuresForm_packagingMeasuresFormInfo__h65ID"};